// Status pill with a theme-driven variant per status. Wraps the generic Pilltag
// which only exposes selected/unselected visual. Detail page + row both use this.

import React from 'react';
import styled from 'styled-components';
import { CAMPAIGN_STATUS } from '../../constants';

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
`;

// Only "active" carries a colored accent — it's the one status with a clear
// positive meaning. The rest sit on a neutral pill so the list doesn't compete
// for attention across multiple semantic colors.
const variantFor = (status, theme) => {
  const c = theme.colors;
  if (status === CAMPAIGN_STATUS.ACTIVE) return { bg: c.SUCCESS_LIGHT, fg: c.SUCCESS_GREEN };
  return { bg: c.NEU_100, fg: c.NEU_600 };
};

const StatusPill = ({ status, theme, ...rest }) => {
  const { bg, fg } = variantFor(status, theme);
  return <Pill role='status' $bg={bg} $fg={fg} {...rest}>{status}</Pill>;
};

export default StatusPill;
